import React, { useEffect } from 'react'
import styled from 'styled-components'

import { themeStyles, themeMedia } from '../../styles/theme'

import PaymentSlider from './paymentsSlider'

import { usePaymentsContext } from '../../context/paymentProvider'

const Wrapper = styled.div`
  padding: 1rem 0 1rem 1rem;
  box-sizing: border-box;
  background-color: ${themeStyles.colors.lightGreys[1].main};
  height: 100px;
  width: 100%;
  position: relative;

  ${themeMedia.tablet`
      padding: 1rem;
  `};

  ${themeMedia.desktop`
      margin: .75rem 0 1.75rem;
      border-radius: 4px;
      padding: 1rem 2rem;
  `};
`

const Method = styled.div`
  cursor: pointer;
  height: 68px;
  background-color: ${themeStyles.colors.white.main};
  border-radius: 3.33px;
  box-sizing: border-box;
  text-align: center;

  &:hover {
    border: 2.22px solid ${themeStyles.colors.lightGreys[2].main};
  }

  &.active {
    border: 2.22px solid ${themeStyles.colors.accentColors.primary.main};
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    margin: 0 auto;
  }
`

const MethodsCarousel = ({ methods, numberOfSlides }) => {
  const { currentMethod, setCurrentMethod } = usePaymentsContext()

  useEffect(() => {
    setCurrentMethod(methods[0])
    // eslint-disable-next-line
  }, [])

  const renderMethodsSlides = () => {
    return methods.map((row) => {
      return (
        <Method
          key={row.paymentMethodCode}
          onClick={() => setCurrentMethod(row)}
          className={
            currentMethod &&
            currentMethod.paymentMethodCode.toLowerCase() ===
              row.paymentMethodCode.toLowerCase()
              ? 'active'
              : ''
          }
        >
          {/* 
            THE FOLLOWING IMAGES ARE COMING FROM UBOS, SO THEY DON'T HAVE WEBP VERSIONS
            SO WE CAN'T USE THE RESPONSIVE IMAGE COMPONENT
          */}
          <picture>
            <img
              align="middle"
              loading="lazy"
              src={`${row.resourceUrl}`}
              alt={`${row.paymentMethodName}`}
            />
          </picture>
        </Method>
      )
    })
  }

  return (
    <Wrapper>
      <PaymentSlider
        slides={renderMethodsSlides(methods)}
        numberOfSlides={numberOfSlides}
      />
    </Wrapper>
  )
}

export default MethodsCarousel
